/*****
 *  created by: danielr
 *
 *  DataSourcesSdesController is responsible for managing the SDEs data sources configuration page
 */

define(function (require) {
    "use strict";

    var lpUtils = require('utils/lpUtils');
    var Page = require("ui.components/page/Page");
    var ManagerConfig = require("manager-assets/config/managerConfig.json");
    var DataSourcesRowsCollection = require("manager-collections/DataSourcesRowsCollection");
    var AttributesConfigLayout = require("manager-views/data-sources/attributes/AttributesConfigLayout");
    var AttributesConfigView = require("manager-views/data-sources/attributes/AttributesConfigView");
    var DataSourcesTagletCollection = require("manager-collections/DataSourcesTagletCollection");
    var ScraperTaglet = require("manager-assets/data/data-sources/scraperTaglet/Taglet.json");
    var MetricsDataSourcesController = require("manager-controllers/MetricsDataSourcesController");
    var DataSourcesList = require("manager-assets/data/data-sources/internal/dataSourcesList.json");
    var AllSdes = require("manager-assets/data/data-sources/sde/Sdes.json");
    var GeneralUtils = require("manager-assets/js/GeneralUtils");
    var SkillsCollection = require("collections/entities/SkillsCollection");
    var SettingsCollection = require("collections/SettingsCollection");
    var SiteSettingsModel = require("models/SiteSettingsModel");
    var ERROR_CODES = require("codeTables/errorCodes.json");

    var DataSourcesSdesController = {};

    var CONST = {
        CLEANUP: "cleanup",
        "TAB_INTEGRATION_INDEX": 1,
        "DATASOURCE_ATTRIBUTE_INDEX": 1,
        "DELETE_ACTION_TYPE": "DELETE"
    };

    LE.module('LEManager', function (LEManager, LE, Backbone, Marionette, $, _) {

        DataSourcesSdesController = Marionette.Controller.extend({

            /****************************************************************** INTERNAL **********************************************************
             *
             */

            initialize:function () {
                LEManager.logger.debug("DataSourcesSdesController:initialize");
                this.channel = LEManager.media.channel("dataSources");
                this.vent = this.channel.vent;
                this.skillsCollection = new SkillsCollection();
                this.fetchSkills();
                this.context = this._getInitContext();
                this._bindEvents();
                this._bindRequests();
            },

            /****************************************************************** PRIVATE **********************************************************
             *
             */

            fetchSkills: function () {
                this.skillsCollection.fetch({
                    reset: true
                });
            },

            /**
             *                                  ############# __bindEvents #############
             *
             * event bindings
             * @private
             */
            _bindEvents: function(){
                LEManager.logger.debug("DataSourcesSdesController:_bindEvents");

                /* fired when changes are done in the scraper section. Used to track unsaved changes before closing the dialog window*/
                this.listenTo(this.vent, ManagerConfig.dataSources.mainConfig.root.TRIGGERING.ABOUT_TO_CLOSE, this._onViewAboutToClose, this);

                /* fired when the AttributesConfigView is renderred so we can call the metrics API*/
                this.listenTo(this.vent, ManagerConfig.dataSources.mainConfig.root.TRIGGERING.CONFIG_VIEW_RENDERED, this._onAttributesConfigViewRendered, this);

                /* fired when the save button is clicked in the scraper section */
                this.listenTo(this.vent,ManagerConfig.dataSources.mainConfig.scraper.TRIGGERING.SCRAPER_SAVE,this._onScraperSaveClick, this);

                /* fired when the save button is clicked in the agent section */
                this.listenTo(this.vent,ManagerConfig.dataSources.mainConfig.agent.TRIGGERING.AGENT_SAVE,this._onAgentSaveClick, this);

                /* fired when changes are done in any properties*/
                this.listenTo(this.vent, ManagerConfig.dataSources.mainConfig.scraper.TRIGGERING.PROPERTIES_CHANGED, this._onScraperPropertiesChanged, this);

                /* fired when changes are done in any agent outcome properties*/
                this.listenTo(this.vent, ManagerConfig.dataSources.mainConfig.agent.TRIGGERING.PROPERTIES_CHANGED, this._onAgentOutcomePropertiesChanged, this);

                /* fired when changes are done in any agent outcome skill*/
                this.listenTo(this.vent, ManagerConfig.dataSources.mainConfig.agent.TRIGGERING.SKILLS_CHANGED, this._onAgentOutcomeSkillsChanged, this);
            },

            _bindRequests: function(){
                this.channel.reply(LE.mediaCodes.manager.reqres.isTagletConfigSupportedByDataSources, this._isTagletConfigSupportedByDataSources, this);
            },

            /**
             *                                  ############# _initPageComponent #############
             *
             * initializes the Page component
             * @private
             */
            _initPageComponent: function(){
                LEManager.logger.debug ("DataSourcesSdesController:_initPageComponent");
                this.pageView = new Page({
                    moduleName:LEManager.moduleName,
                    context:LE.context,
                    header: {
                        title: "",
                        description: ""
                    },
                    hasActionStrip: false
                });
                this.listenTo(this.pageView, "close", _.bind(this._onPageClose, this, this.pageView));
            },

            /**
             *                                  ############# _getInitContext #############
             *
             * initialize the contextual data.
             * - rowModel: the requested row model (to retrieve connections for)
             * - attributeModel: the requested attribute model (to scroll to)
             * @returns context object
             * @
             */
            _getInitContext: function(){
                LEManager.logger.debug("DataSourcesSdesController:_getInitContext");

                var result = {
                    rowModel: null,
                    attributeModel: null,
                    metrics: null, //data from the metrics API
                    allProperties: null,  //all the properties ,
                    scraperSave: {}, //to know if the save ispartial or full (attributes' save button or close button pressed
                    agentSave: {},
                    isTagletConfigSupported: true
                };
                return result;
            },


            /****************************************** PRIVATE > Navigation ****************************/


            /**
             *                                  ############# _navigateOut #############
             *
             * is triggered everytime the page's X button or the Done button are clicked
             */
            _navigateOut: function() {
                LEManager.logger.debug("DataSourcesSdesController:_navigateOut");

                /*var previousApplicationRoute = LE.context.get("previousApplicationRoute");
                if (_.isUndefined(previousApplicationRoute)){ //in case of this page is loaded directly (first navigation), if close is pressed then redirect to the data sources page
                    LEManager.router.navigateNonBackable(ManagerConfig.dataSources.mainConfig.general.dataSourcesListRoutePath);
                    return;
                }*/

                LEManager.router.navigateBack();

            },


            /**
             *                                  ############# _onPageClose #############
             *
             * is called everytime the PageView is being closed
             */
            _onPageClose: function(closedPageView) {
                LEManager.logger.debug("DataSourcesSdesController:_onPageClose");

                if (closedPageView) {
                    this.stopListening(closedPageView);
                }

                if (this.pageView && closedPageView && closedPageView.cid === this.pageView.cid) {
                    this.pageView = null;
                    this.attributesConfigLayout = null;
                }
            },

            /***************
             *
             *       BUILD CONFIGURATION VIEWS (SCRAPER AND CODE)
             *
             ***************/


            /**
             *                                  ############# _initDataSourcesRowsCollection #############
             *
             * gets the data sources rows collection (dataSourcesRowCollection)
             * the original collection is also saved in order to save in the taglet the data that is out of the
             * saved model scope (in case of a single save model is clicked)
             *
             * @private
             */
            _initDataSourcesRowsCollection: function(){
                LEManager.logger.debug("DataSourcesSdesController:_initDataSourcesRowsCollection");

                this.dataSourcesRowsCollection = new DataSourcesRowsCollection();
                this.originalRowsCollection = new DataSourcesRowsCollection();

                var list = DataSourcesList.tabs[CONST.TAB_INTEGRATION_INDEX].categories[CONST.DATASOURCE_ATTRIBUTE_INDEX].rows;
                //we clone the json list and pass it to the collection so that is no reference issue
                var originalList = _.clone(DataSourcesList.tabs[CONST.TAB_INTEGRATION_INDEX].categories[CONST.DATASOURCE_ATTRIBUTE_INDEX].rows, true);

                this.dataSourcesRowsCollection.add(list);
                this.originalRowsCollection.add(originalList);

            },

            /**
             *                                  ############# _getDataSourcesJsonMetrics #############
             *
             * get all the SDES metrics count displayed in the page from API
             *
             * @private
             */
            _getDataSourcesJsonMetrics: function(){
                LEManager.logger.debug("DataSourcesSdesController:_getDataSourcesJsonMetrics - started");

                /* get the metric types to be sent to the API */
                var metricTypes = this.context.rowModel.getAttributesMetricsNames();

                /* call the reporting metric API */
                MetricsDataSourcesController.getDataSourcesJsonMetrics({
                    types: metricTypes,
                    success: _.bind(this._onDataSourcesJsonMetricsSuccess, this),
                    error: _.bind(this._onDataSourcesJsonMetricsError, this)
                });
            },

            /**
             *                                  ############# _onDataSourcesJsonMetricsSuccess #############
             *
             * the SDES metrics count API is fetched successfully. we can update the collection with the connections value
             *
             * @param data - fetched data
             * @private
             */
            _onDataSourcesJsonMetricsSuccess: function(data){
                LEManager.logger.debug("DataSourcesSdesController:_onDataSourcesJsonMetricsSuccess - started");

                var dataMetrics = data.get("dataMetrics");
                this.context.metrics = dataMetrics;
                //update the connection fields based on the metrics count api
                this._updateConnectionsFromMetrics();
            },

            /**
             *                                  ############# _updateConnectionsFromMetrics #############
             *
             * update the connection fields in the for all the attributes from the metrics api
             *
             * @private
             */
            _updateConnectionsFromMetrics: function(){
                LEManager.logger.debug("DataSourcesSdesController:_updateConnectionsFromMetrics - started");

                this.context.rowModel.updateMetricsConection(this.context.metrics);
            },

            /**
             *                                  ############# _onDataSourcesJsonMetricsError #############
             *
             * the SDES metrics count API failed to be fetched.
             *
             * @param model - not in use
             * @param data - not in use
             * @private
             */
            _onDataSourcesJsonMetricsError: function(model, data){
                LEManager.logger.error("DataSourcesSdesController:_onDataSourcesJsonMetricsError");
                this.context.metrics = null;
            },


            /**
             *                                  ############# _getTagletData #############
             *
             * fetch the taglet api
             *
             */
            _getTagletData: function(done){
                LEManager.logger.debug("DataSourcesSdesController:_getTagletData - started");

                this.dataSourcesTagletCollection = new DataSourcesTagletCollection();

                this.pageView.showLoader();

                /* fetch the scraper taglet API */
                this.dataSourcesTagletCollection.fetch({
                    success: _.bind(this._onTagletCollectionFetchSuccess, this, done),
                    error: _.bind(this._onTagletCollectionFetchError, this, done)
                });
            },

            /**
             *                                  ############# _getAgentOutcome #############
             *
             * fetch the agent outcome api
             *
             */
            _getAgentOutcome: function(done){
                LEManager.logger.debug("DataSourcesSdesController:_getAgentOutcome - started");

                this.pageView.showLoader();

                /* fetch the agent outcome API */
                this.siteSettingsModel = new SiteSettingsModel({
                    id: SettingsCollection.SETTINGS_ENUM.SETTING_ID.AGENT_OUTCOME
                });
                this.siteSettingsModel.fetch({
                    success: _.bind(this._onAgentOutcomeFetchSuccess, this, done),
                    error: _.bind(this._onAgentOutcomeFetchError, this, done)
                });
            },

            /**
             *                                  ############# _mapTagletJsonToRowModel #############
             *
             * maps taglet json with the RowModel.
             * we loop through all the parameters values saved in the taglet.
             * we identify what is the corresponding row model and we update its properties accordingly
             *
             * @param rowsCollection - the rows collection we want to map
             * @param tagletJson - the json from the taglet API
             * @param setModelOptions - the options we want to apply when setting the property model (silent true or false)
             * @private
             */
            _mapTagletJsonToRowModel: function(rowsCollection, tagletJson, setModelOptions){
                LEManager.logger.debug("DataSourcesSdesController:_mapTagletJsonToRowModel");

                var attributeId = null, dataSourcesAttributeModel = null, propertyModel = null, key = "", mapById = -1, mapByValue = "", originalAttributeModel=null, originalPropertyModel= null;
                _.each(tagletJson, function(data){
                    attributeId = data.id;
                    dataSourcesAttributeModel = rowsCollection.getAttributeById(attributeId);
                    if (!_.isUndefined(dataSourcesAttributeModel)){
                        if (data.value.lookup){
                            for (var prop in data.value.lookup){
                                propertyModel = dataSourcesAttributeModel.getPropertiesCollection().getById(window.parseInt(prop));
                                if (!_.isUndefined(propertyModel)){
                                    key = window.Object.keys(data.value.lookup[prop])[0];
                                    mapById = ManagerConfig.dataSources.mapping.mapToTaglet[key];
                                    mapByValue = data.value.lookup[prop][key];
                                    propertyModel.setMapById(mapById, setModelOptions);
                                    propertyModel.setMapByValue(mapByValue, setModelOptions);
                                }
                            }
                        }
                    }
                });
            },

            /**
             *                                  ############# _onEditItemCollectionFetchSuccess #############
             *
             * once taglet is fetched successfully we populate the dataSourcesRowsCollection accordingly
             *
             * If the API returns 404, it means that the taglet does not exist in repository. the internal json will be used to populate the collections
             *
             * @param collection - the data returened by the API
             * @param response - returned by the API - not in use
             * @param options - used to check http status and response
             * @private
             */
            _onTagletCollectionFetchSuccess: function(done, collection, response, options){
                LEManager.logger.debug("DataSourcesSdesController:_onTagletCollectionFetchSuccess - started");

                this.pageView.closeLoader();
                this.tagletModel = collection.getTagletModel();

                if (this.tagletModel.hasParametersDefined()){
                    /* the taglet exists in repository. retrieve it and store relevant config */
                    LEManager.logger.debug("DataSourcesSdesController:_onEditItemCollectionFetchSuccess - the taglet exists in repository. retrieve it and store relevant config");
                    var parameters = this.tagletModel.getParametersConfig();
                    LEManager.logger.debug("taglet parameters found. parameters: " + parameters, "DataSourcesSdesController:_onEditItemCollectionFetchSuccess");
                    this.context.isTagletConfigSupported = this._checkTagletConfigIsCompatibleWithDataSource(parameters);

                    if (this.context.isTagletConfigSupported){
                        this._mapTagletJsonToRowModel(this.dataSourcesRowsCollection, parameters, {});
                        this._mapTagletJsonToRowModel(this.originalRowsCollection, parameters, {silent:true});
                    }
                    else {
                        //taglet config is not supported most probably because it has been configured by a third party tool
                        LEManager.notifier.showError({
                            title: LE.translator.translate("LEManager.manager.dataSources.config.data.not.compatible.title"),
                            content: LE.translator.translate("LEManager.manager.dataSources.config.data.not.compatible.message"),
                            objectAction: {
                                text: LE.translator.translate("LEFramework.global.captions.ok"),
                                callback: function(){}
                            },
                            removeAditionalButton: true
                        });
                    }
                }
                done();
            },

            _checkTagletConfigIsCompatibleWithDataSource: function(tagletJson){
                LEManager.logger.debug("DataSourcesSdesController:_checkTagletConfigIsCompatibleWithDataSource");

                var isTagletConfigSupported=true, attributeId = null, dataSourcesAttributeModel = null, keys = null;
                try {
                    _.each(tagletJson, _.bind(function(data){
                        attributeId = data.id;
                        //first check that attribute model can be defined according the id in the taglet
                        dataSourcesAttributeModel = this.dataSourcesRowsCollection.getAttributeById(attributeId);
                        isTagletConfigSupported = isTagletConfigSupported && !_.isNull(dataSourcesAttributeModel);

                        //check that the properties in the taglet are compliant
                        for (var prop in data.value.lookup){
                            //the prop should be an integer and its config must be plain object and not an array
                            if (isTagletConfigSupported && !window.isNaN(prop) && !_.isArray(data.value.lookup[prop])){
                                keys = _.keys(data.value.lookup[prop]);
                                //check for supported properties only
                                isTagletConfigSupported = isTagletConfigSupported && !this._checkUnsupportedTagletConfig(keys);
                            }
                        }
                    }, this));
                }
                catch (ex){
                    LEManager.logger.debug("not supported taglet configuration");
                    isTagletConfigSupported = false;
                }
                return isTagletConfigSupported;
            },

            _checkUnsupportedTagletConfig: function(lookupKeys){
                var supportedKeyNames = ManagerConfig.dataSources.mainConfig.scraper.SUPPORTED_SCRAPING_PROPERTIES;
                var foundNotSupported = false;
                _.each(lookupKeys, function(lookupKey){
                    foundNotSupported = foundNotSupported || supportedKeyNames.indexOf(lookupKey) < 0;
                });
                return foundNotSupported;
            },

            _isTagletConfigSupportedByDataSources: function(){
                return this.context.isTagletConfigSupported;
            },

            _renderAttributesConfigView: function() {
                /* now that all the collections are populated, bind the view */
                this.attributesConfigView = new AttributesConfigView({
                    collection: this.context.rowModel.getAttributesCollection(),
                    selectedAttributeModel: this.context.attributeModel,
                    selectedRowModel: this.context.rowModel,
                    skillsCollection: this.skillsCollection
                });
                this.attributesConfigLayout.mainRegion.show(this.attributesConfigView);
            },

            /**
             *                                  ############# _onTagletCollectionFetchError #############
             *
             * the taglet API failed.
             *
             * @param data
             * @param response
             * @param options
             * @private
             */
            _onTagletCollectionFetchError: function(done, data, response, options){
                LEManager.logger.error("error on fetching taglet collection. error: " + response, "DataSourcesSdesController:_onTagletCollectionFetchError");

                this.pageView.closeLoader();
                LEManager.logger.error("DataSourcesSdesController:_onTagletCollectionFetchError - " + data);
                LEManager.notifier.showError({
                    content: LE.translator.translate("LEManager.manager.dataSources.api.global.error")
                });
                done();
            },

            /**
             *                                  ############# _onAgentOutcomeFetchSuccess #############
             *
             * once agent outcome is fetched successfully we populate the dataSourcesRowsCollection accordingly
             *
             * @param model - the data returened by the API
             * @param response - returned by the API - not in use
             * @param options - used to check http status and response
             * @private
             */
            _onAgentOutcomeFetchSuccess: function(done, model, response, options) {
                LE.siteSettings.agentOutcomeSettings.setAgentOutcome(model && model.getValue());
                LEManager.logger.debug("DataSourcesSdesController:_onAgentOutcomeFetchSuccess - started");

                this.pageView.closeLoader();

                var outcomeJson = model && model.getValue() || {};

                //proceed with mapping and populate the original and current collections
                this._mapAgentOutcomeToRowModel(this.dataSourcesRowsCollection, outcomeJson, {});
                this._mapAgentOutcomeToRowModel(this.originalRowsCollection, outcomeJson, {silent:true});

                done();
            },

            /**
             *                                  ############# _mapAgentOutcomeToRowModel #############
             *
             * maps agent outcome with the RowModel.
             * we loop through all the parameters values saved in the agent outcome model.
             * we identify what is the corresponding row model and we update its properties accordingly
             *
             * @param rowsCollection - the rows collection we want to map
             * @param outcomeJson - the model propertyValue value json from the settings API
             * @param setModelOptions - the options we want to apply when setting the property model (silent true or false)
             * @private
             */
            _mapAgentOutcomeToRowModel: function(rowsCollection, outcomeJson, setModelOptions) {
                var attrModel;
                var sde;
                var propCollection;

                function comperator(sde){
                    return sde.value.sde.type === attr;
                }

                function setter(val, name) {
                    var alias = propCollection.search(name + "$");
                    alias.setAgentDisplayNameValue(val, setModelOptions);
                }

                for (var attr in outcomeJson) {
                    if (outcomeJson.hasOwnProperty(attr)) {
                        sde = _.find(AllSdes, comperator);

                        if (sde) {
                            attrModel = rowsCollection.getAttributeById(sde.id);

                            if (attrModel) {
                                if (outcomeJson[attr].skills) {
                                    attrModel.set("agentOutcome.skills", outcomeJson[attr].skills, setModelOptions);
                                }

                                if (outcomeJson[attr].alias) {
                                    propCollection = attrModel.getPropertiesCollection();

                                    if (propCollection) {
                                        _.each(outcomeJson[attr].alias, setter, this);
                                    }
                                }
                            }
                        }
                    }
                }
            },

            /**
             *                                  ############# _onAgentOutcomeFetchError #############
             *
             * the agent outcome API failed.
             *
             * @param data
             * @param response
             * @param options
             * @private
             */
            _onAgentOutcomeFetchError: function(done, data, response, options){
                LEManager.logger.debug("DataSourcesSdesController:_onAgentOutcomeFetchError");

                this.pageView.closeLoader();
                LEManager.logger.error("DataSourcesSdesController:_onAgentOutcomeFetchError - " + data);
                LEManager.notifier.showError({
                    content: LE.translator.translate("LEManager.manager.dataSources.api.global.error")
                });
                done();
            },

            _onAttributesConfigViewRendered: function(obj){
                // get connections value from metrics api
                this._getDataSourcesJsonMetrics();
            },

            _onScraperPropertiesChanged: function(propertyModel){
                var attributeModel = this.dataSourcesRowsCollection.getAttributeById(propertyModel.getParentId());
                attributeModel.hasUnsavedScraperProperties = true;
            },

            _onAgentOutcomePropertiesChanged: function(propertyModel){
                var attributeModel = this.dataSourcesRowsCollection.getAttributeById(propertyModel.getParentId());
                attributeModel.hasUnsavedAgentOutcomeProperties = true;
            },

            _onAgentOutcomeSkillsChanged: function (attributeModel) {
                attributeModel.hasUnsavedAgentOutcomeProperties = true;
            },

            /**
             *                                  ############# _onViewAboutToClose #############
             *
             * triggered when the scraper dialog is about to close - we need to track if we have unsaved changes
             *
             * @param obj - not in use
             * @private
             */
            _onViewAboutToClose: function(obj){
                LEManager.logger.debug("DataSourcesSdesController:_onViewAboutToClose");

                if (this._checkExistingScraperChanges() || this._checkExistingAgentOutcomeChanges()){
                    //there are unsaved changes - display a notification message
                    this._displaySaveBeforeChangesNotification();
                }
                else {
                    //there are no unsaved changes - the scraper dialog can be safely closed
                    this._closeScraperDialogWithoutSaving();
                }
            },

            _getUnsavedAttributesData: function () {
                return this.context.rowModel.getUnsavedAttributesData();
            },

            _getUnsavedScraperAttributesData: function () {
                var unsavedAttributesData = this._getUnsavedAttributesData();
                var unsavedScraperData = _.where(unsavedAttributesData, function (data) {
                    return data.tabType === ManagerConfig.dataSources.mainConfig.tabType.scraper;
                });
                return unsavedScraperData;
            },

            _getUnsavedAgentOutcomeAttributesData: function () {
                var unsavedAttributesData = this._getUnsavedAttributesData();
                var unsavedAgentOutcomeData = _.where(unsavedAttributesData, function (data) {
                    return data.tabType === ManagerConfig.dataSources.mainConfig.tabType.agent;
                });
                return unsavedAgentOutcomeData;
            },

            /**
             *                                  ############# _checkExistingScraperChanges  #############
             *
             * checks if there are unsaved data in the page
             *
             * @returns {boolean}
             * @private
             */
            _checkExistingScraperChanges: function(){
                LEManager.logger.debug("DataSourcesSdesController:_checkExistingScraperChanges");
                var unsavedScraperData = this._getUnsavedScraperAttributesData();
                return unsavedScraperData.length > 0;
            },

            /**
             *                                  ############# _checkExistingAgentOutcomeChanges #############
             *
             * checks if there are unsaved data in the page
             *
             * @returns {boolean}
             * @private
             */
            _checkExistingAgentOutcomeChanges: function(){
                LEManager.logger.debug("DataSourcesSdesController:_checkExistingAgentOutcomeChanges");
                var unsavedAgentOutcomeData = this._getUnsavedAgentOutcomeAttributesData();
                return unsavedAgentOutcomeData.length > 0;
            },

            /**
             *                                  ############# _displaySaveBeforeChangesNotification #############
             *
             * display a notification message in case of unsaved changes.
             * 3 options:
             * - cancel (and coming back to the scraper view)
             * - exit without saving
             * - save (all changes)
             *
             * @private
             */
            _displaySaveBeforeChangesNotification: function(){
                LEManager.logger.debug("DataSourcesSdesController:_displaySaveBeforeChangesNotification");
                var foundUnsavedAgentOutcomeChanges = this._checkExistingAgentOutcomeChanges();
                this.confirmNotifier = LEManager.notifier.showConfirm({
                    title: LE.translator.translate("LEFramework.global.captions.are.you.sure"),
                    content: this._getUnsavedNotificationContent(),
                    removeMiddleButton: foundUnsavedAgentOutcomeChanges,
                    objectAction: this._generateNotifierObjectAction()
                });
            },

            _getUnsavedNotificationContent: function(){
                var foundUnsavedScrapingChanges = this._checkExistingScraperChanges();
                var foundUnsavedAgentOutcomeChanges = this._checkExistingAgentOutcomeChanges();
                var tabText, content;
                if (foundUnsavedAgentOutcomeChanges) {
                    var unsavedAgentOutcomeData = this._getUnsavedAgentOutcomeAttributesData();
                    tabText = LE.translator.translate("LEManager.manager.dataSources.edit.unsaved.changes.notification.agentOutcome.tab");
                    content = this._getUnsavedNotificationContentText(unsavedAgentOutcomeData, tabText);
                    return content;
                }
                else if (foundUnsavedScrapingChanges){
                    var unsavedScraperData = this._getUnsavedScraperAttributesData();
                    tabText = LE.translator.translate("LEManager.manager.dataSources.edit.unsaved.changes.notification.scraper.tab");
                    content = this._getUnsavedNotificationContentText(unsavedScraperData, tabText);
                    return content;
                }
            },

            _getUnsavedNotificationContentText: function(unsavedData, tabText){
                var namesList = this._generateUnsavedNotificationContentNamesList(unsavedData);
                var content = LE.translator.translate("LEManager.manager.dataSources.edit.unsaved.changes.notification");
                return content.replace("{0}", namesList).replace("{1}", tabText);
            },

            _generateUnsavedNotificationContentNamesList: function(data){
                var names = [];
                _.each(data, function(item){
                    names.push(item.name);
                });
                return names.join(", ");
            },

            _generateNotifierObjectAction: function(){
                var foundUnsavedScrapingChanges = this._checkExistingScraperChanges();
                var foundUnsavedAgentOutcomeChanges = this._checkExistingAgentOutcomeChanges();
                var objectAction = {
                    cancelCallback: _.bind(function() {
                        this.confirmNotifier.close();
                    }, this)
                };
                if (foundUnsavedAgentOutcomeChanges){
                    objectAction.text = LE.translator.translate("LEManager.manager.dataSources.edit.scraper.cancel.caption.notification");
                    objectAction.callback = _.bind(function(){
                        this.confirmNotifier.close();
                        this._closeScraperDialogWithoutSaving();
                    }, this);
                }
                else if (foundUnsavedScrapingChanges) {
                    objectAction.text = LE.translator.translate("LEFramework.global.captions.save");
                    objectAction.callback = _.bind(function(){
                        this.confirmNotifier.close();
                        this._saveAllScraperChanges();
                    }, this);
                    objectAction.textMiddleButton = LE.translator.translate("LEManager.manager.dataSources.edit.scraper.cancel.caption.notification");
                    objectAction.middleCallback = _.bind(function(){
                        this.confirmNotifier.close();
                        this._closeScraperDialogWithoutSaving();
                    }, this);
                }
                return objectAction;
            },

            /**
             *                                  ############# _saveAllScraperChanges #############
             *
             * if all the data is valid, save is called
             *
             * @private
             */
            _saveAllScraperChanges: function(){
                LEManager.logger.debug("DataSourcesSdesController:_saveAllScraperChanges");

                this.context.scraperSave = {saveAll: true};
                var isValid = this.context.rowModel.arePropertiesValid();

                if (isValid){
                    //all is valid - save the data (all sdes)
                    this._prepareSaveData();
                }
                else {
                    //not valid - display a notification error message
                    this._displayValidationErrorMsg();
                }
            },


            /**
             *                                  ############# _displayValidationErrorMsg #############
             *
             * display the validation error message
             *
             * @private
             */
            _displayValidationErrorMsg: function(){
                LEManager.logger.debug("DataSourcesSdesController:_displayValidationErrorMsg");

                LEManager.notifier.showError({
                    content: LE.translator.translate("LEManager.manager.dataSources.edit.validation.error")});
            },


            /**
             *                                  ############# _closeScraperDialogWithoutSaving #############
             *
             * closes the scraper dialog without saving any changes - exit the dialog
             *
             * @private
             */
            _closeScraperDialogWithoutSaving: function(){
                LEManager.logger.debug("DataSourcesSdesController:_closeScraperDialogWithoutSaving");
                this._navigateOut();
            },






            /******************
             *
             *       SAVE SCRAPER AREA
             *
             ****************/


            /**
             *                                  ############# _onScraperSaveClick #############
             *
             * save specific SDE scraper
             *
             * @param attributeModel - the model we want to save
             * @private
             */
            _onScraperSaveClick: function(attributeModel){
                LEManager.logger.info("DataSourcesSdesController:_onScraperSaveClick - started");

                this.context.scraperSave = {saveAll: false, model: attributeModel};
                var isValid = attributeModel.arePropertiesValid();

                if (isValid){
                    //the model is valid - save the data
                    this._prepareSaveData();
                }
                else {
                    //not valid - display a notification error message
                    this._displayValidationErrorMsg();
                }

            },

            /**
             *                                  ############# _onAgentSaveClick #############
             *
             * save specific SDE scraper
             *
             * @param data - the data model we want to save
             * @private
             */
            _onAgentSaveClick: function(data){
                LEManager.logger.info("DataSourcesSdesController:_onAgentSaveClick - started");

                this.context.agentSave = {saveAll: false, data: data, model: data.model};
                this._prepareAgentOutcomeSaveData();
            },

            /**
             *                                  ############# _prepareAgentOutcomeSaveData #############
             *
             *
             * @private
             */
            _prepareAgentOutcomeSaveData: function () {
                LEManager.logger.info("DataSourcesSdesController:_prepareAgentOutcomeSaveData - started");

                //we need to build the outcome API request
                LEManager.logger.info("DataSourcesSdesController:_prepareAgentOutcomeSaveData - we need to build the outcome API request");
                var settings = this._buildAgentOutcomeSiteSettingsJson();
                var outcome = settings.outcome;
                var valid = settings.valid;
                var isDelete = !outcome;

                var beforeComplete = _.bind(function() {
                    this.pageView.closeLoader();
                }, this);

                if (isDelete) {
                    //send a delete request with no body in the request only if all the properties for all the SDEs (even the one that are not displayed in the page) are blanks
                    LEManager.logger.info("DataSourcesSdesController:_prepareAgentOutcomeSaveData - isDelete is true - we will send an empty body delete request");

                    this.siteSettingsModel = new SiteSettingsModel({
                        id: SettingsCollection.SETTINGS_ENUM.SETTING_ID.AGENT_OUTCOME
                    });
                    this.siteSettingsModel.destroy({
                        success: _.bind(function(valid) {
                            LE.siteSettings.agentOutcomeSettings.setAgentOutcome(void 0);
                            beforeComplete();
                            LEManager.notifier.showSuccess({
                                content: LE.translator.translate("LEManager.manager.dataSources.edit.agent.save.success")
                            });
                            this._emitSaveAgentOutcomeDone(true, this.context.agentSave.model);
                        }, this, valid),
                        error:  _.bind(function(valid, model, response) {
                            beforeComplete();
                            var content = LE.translator.translate("LEManager.manager.dataSources.edit.agent.save.error");
                            if(response && response.responseError && response.responseError.code === ERROR_CODES.wrongRevision){
                                content = LE.translator.translate("LEFramework.errors.serverError.1001");
                            }
                            LE.notifier.showError({
                                content: content
                            });
                            this._emitSaveAgentOutcomeDone(false);
                        }, this, valid)
                    });

                }
                else {
                    this.pageView.showLoader();

                    // Cloning the object before modifying it.
                    // This is important because _.extend() will access the model without using the formal setValue method,
                    // Which might then lead to bugs.
                    var oldValue = lpUtils.cloneObject(this.siteSettingsModel.getValue());
                    // Adding newly set data to the previously saved data from other tabs.
                    var newValue = _.extend(oldValue, outcome);

                    this.siteSettingsModel.unSetPropertyValue();
                    this.siteSettingsModel.setValue(newValue);
                    this.siteSettingsModel.save(null, {
                        success: _.bind(function(valid, model) {
                            LE.siteSettings.agentOutcomeSettings.setAgentOutcome(model && model.getValue());
                            beforeComplete();
                            this.context.agentSave.model.hasUnsavedAgentOutcomeProperties = false;
                            if (valid) {
                                LEManager.notifier.showSuccess({
                                    content: LE.translator.translate("LEManager.manager.dataSources.edit.agent.save.success")
                                });
                            }
                            else {
                                LEManager.notifier.showWarning({
                                    content: LE.translator.translate("LEManager.manager.dataSources.edit.agent.save.no.properties.warning")
                                });
                            }
                            this._emitSaveAgentOutcomeDone(true, this.context.agentSave.model);
                        }, this, valid) ,
                        error: _.bind(function(valid, model, response, options) {
                            beforeComplete();
                            var content = LE.translator.translate("LEManager.manager.dataSources.edit.agent.save.error");
                            if(response && response.responseError && response.responseError.code === ERROR_CODES.wrongRevision){
                                content = LE.translator.translate("LEFramework.errors.serverError.1001");
                            }
                            LE.notifier.showError({
                                content: content
                            });
                            this._emitSaveAgentOutcomeDone(false);
                        }, this, valid)
                    });
                }
            },

            /**
             *                                  ############# _buildAgentOutcomeSiteSettingsJson #############
             *
             *
             * @private
             */
            _buildAgentOutcomeSiteSettingsJson: function() {
                LEManager.logger.info("DataSourcesSdesController:_buildAgentOutcomeSiteSettingsJson - started");

                var valid = false;
                var outcomeSde = {};
                var outcome;
                var agentOutcome;
                var aliases;
                var split;
                var name;
                var sde;

                if (this.context.agentSave.data && this.context.agentSave.data.model) {
                    if (this.context.agentSave.data.collection) {
                        _.each(this.context.agentSave.data.collection.models, function(model){
                            if (!model.arePropertiesBlank(true)) {
                                split = model.get("SDEPath").split(".");
                                name = split[split.length - 1];
                                aliases = aliases || {};
                                aliases[name] = model.getAgentDisplayNameValue();
                            }
                        }, this);
                    }

                    for (var i = 0; i < AllSdes.length; i++) {
                        sde = AllSdes[i];
                        if (sde && parseInt(sde.id, 10) === this.context.agentSave.data.model.id) {
                            name = sde.value && sde.value.sde && sde.value.sde.type;

                            if (name) {
                                agentOutcome = _.extend({ skills: [] }, this.context.agentSave.data.model.get("agentOutcome") || {});
                                outcome = {};
                                if (aliases) {
                                    valid = true;
                                    outcomeSde.alias = aliases;
                                    outcome[name] = _.extend(outcomeSde, agentOutcome);
                                }
                                else {
                                    outcome[name] = null;
                                }

                                break;
                            }
                        }
                    }
                }

                return {
                    outcome: outcome,
                    valid: valid
                };
            },
            /**
             *                                  ############# _prepareSaveData #############
             *
             *
             * @private
             */
            _prepareSaveData: function () {
                LEManager.logger.info("DataSourcesSdesController:_prepareSaveData - started");

                var isDelete = this._isDeleteAction();
                LEManager.logger.debug("isDelete: " + isDelete, "DataSourcesSdesController:_prepareSaveData");

                if (isDelete) {
                    //send a delete request with no body in the request only if all the properties for all the SDEs (even the one that are not displayed in the page) are blanks
                    LEManager.logger.info("DataSourcesSdesController:_prepareSaveData - isDelete is true - we will send an empty body delete request");

                    this._postTagletRequest(null, {isNew: false, isDelete: true});
                }
                else {
                    //we need to build the taglet API request
                    LEManager.logger.info("DataSourcesSdesController:_prepareSaveData - we need to build the taglet API request");

                    this._buildSDETaglet();
                }

            },

            /**
             *                                  ############# _buildSDETaglet #############
             *
             * build the taglet request to submit to the API
             *
             * @private
             */
            _buildSDETaglet: function(){
                LEManager.logger.info("DataSourcesSdesController:_buildSDETaglet - started");

                //we build the taglet info ready to be posted
                var parametersJson = this._buildScraperConfigJson();
                LEManager.logger.debug("parametersJson: " + parametersJson, "DataSourcesSdesController:_buildSDETaglet");

                var isNew = !this.tagletModel.hasParametersDefined();
                LEManager.logger.debug("isNew: " + isNew, "DataSourcesSdesController:_buildSDETaglet");

                var status = {isDelete: false, isNew: isNew};

                if (parametersJson !== []) {
                    //build the scraper taglet request
                    var tagletRequest = this._buildTagletRequest(parametersJson);
                    LEManager.logger.debug("tagletRequest: " + tagletRequest, "DataSourcesSdesController:_buildSDETaglet");

                    //submit the taglet request to the API
                    this._postTagletRequest(tagletRequest, status);
                }
                else {
                    //emit a save scraper done event
                    this._emitSaveScraperDone(false);
                }
            },

            /**
             *                                  ############# _isDeleteAction #############
             *
             * checks if we need to perform a delete action or not
             *
             * @returns {*}
             * @private
             */
            _isDeleteAction: function(agent){
                LEManager.logger.info("DataSourcesSdesController:_isDeleteAction - started");

                return this.dataSourcesRowsCollection.areAllPropertiesBlank(agent);
            },


            /**
             *                                  ############# _postTagletRequest #############
             *
             * submit the taglet request to the API
             *
             * @param tagletRequest - the request
             * @param status - new, edit or delete
             * @private
             */
            _postTagletRequest: function(tagletRequest, status){
                LEManager.logger.info("DataSourcesSdesController:_postTagletRequest - started");

                this.pageView.showLoader();
                this.tagletModel.saveTaglet(
                    status,
                    tagletRequest,
                    {
                        success:_.bind(this._onPostTagletSuccess, this),
                        error:_.bind(this._onPostTagletError, this)
                    });
            },

            /**
             *                                  ############# _onPostTagletSuccess #############
             *
             * scraper taglet submit success callback
             *
             * @param model - not in use
             * @param resp - the response
             * @param options - not in use
             * @private
             */
            _onPostTagletSuccess: function(model, resp, options){
                LEManager.logger.info("DataSourcesSdesController:_onPostTagletSuccess - started");

                LEManager.notifier.showSuccess({
                    content: LE.translator.translate("LEManager.manager.dataSources.edit.scraper.save.success")
                });
                if (this.context.scraperSave.saveAll){
                    LEManager.logger.info("navigating out, save all performed - DataSourcesSdesController:_onPostTagletSuccess");
                    this._navigateOut();
                }
                else {//single save section - we remain on the page
                    if (options.type === CONST.DELETE_ACTION_TYPE){//if a delete action has been performed then reset the propertiesChange context to false
                        this.context.rowModel.attributesCollection.resetUnsavedScraperAttributesData();
                        this.tagletModel.resetConfigs();
                    }
                    else {
                        this.context.scraperSave.model.hasUnsavedScraperProperties = false;
                        this._updateOriginalCollection();
                    }
                    this._emitSaveScraperDone(true, this.context.scraperSave.model);
                }
            },

            _updateOriginalCollection: function(){
                LEManager.logger.info("DataSourcesSdesController:_updateOriginalCollection - started");
                var parameters = this.tagletModel.getParametersConfig();
                LEManager.logger.debug("parameters: " + parameters, "DataSourcesSdesController:_updateOriginalCollection - started");
                this._mapTagletJsonToRowModel(this.originalRowsCollection, parameters, {silent:true});
            },

            /**
             *                                  ############# _onPostTagletError #############
             *
             * scraper taglet submit error callback
             *
             * @param model - not in use
             * @param resp - not in use
             * @param options  - not in use
             * @private
             */
            _onPostTagletError: function(model, resp, options){
                LEManager.logger.info("DataSourcesSdesController:_onPostTagletError - started");

                LE.notifier.showError({
                    content: LE.translator.translate("LEManager.manager.dataSources.edit.scraper.save.error")
                });
                this._emitSaveScraperDone(false);
            },

            /**
             *                                  ############# _emitSaveScraperDone #############
             *
             * the save action is done - trigger relevant event
             *
             * @param isSuccess - if the save is successful
             * @param saveModel [optional] - the model we save
             */
            _emitSaveScraperDone: function(isSuccess, saveModel){
                LEManager.logger.info("DataSourcesSdesController:_emitSaveScraperDone - started");
                this.pageView.closeLoader();
                this.vent.trigger(ManagerConfig.dataSources.mainConfig.scraper.TRIGGERING.SCRAPER_SAVE_DONE, {isSuccess: isSuccess, saveAll: this.context.scraperSave.saveAll, model: saveModel});
            },

            /**
             *                                  ############# _emitSaveAgentOutcomeDone #############
             *
             * the save action is done - trigger relevant event
             *
             * @param isSuccess - if the save is successful
             * @param saveModel [optional] - the model we save
             */
            _emitSaveAgentOutcomeDone: function(isSuccess, saveModel){
                LEManager.logger.info("DataSourcesSdesController:_emitSaveAgentOutcomeDone - started");
                this.pageView.closeLoader();
                this.vent.trigger(ManagerConfig.dataSources.mainConfig.agent.TRIGGERING.AGENT_SAVE_DONE, {isSuccess: isSuccess, saveAll: this.context.agentSave.saveAll, model: saveModel});
            },

            /**
             *                                  ############# _buildTagletRequest #############
             *
             * build the taglet request
             *
             * @param strJson - the SDEs json
             * @returns {*}
             * @private
             */

            _buildTagletRequest: function(parametersJson){
                LEManager.logger.info("DataSourcesSdesController:_buildTagletRequest - started");

                var taglet = ScraperTaglet;
                taglet.revision = parseInt(this.tagletModel.getRevision(), 10);
                taglet.tagletConfigs[0].accountId = LE.sessionManager.getAccountId();
                taglet.tagletConfigs[0].tagletName = this.tagletModel.getTagletName();
                taglet.tagletConfigs[0].tagletVersion = this.tagletModel.getTagletVersion();
                taglet.tagletConfigs[0].parameters = parametersJson;

                LEManager.logger.debug("taglet request: " + taglet, "DataSourcesSdesController:_buildTagletRequest - started");
                return taglet;
            },

            /**
             *                                  ############# _buildScraperConfigJson #############
             *
             * builds the scraper info json based on the data in the rows collection (original and current).
             * - if a single save has been clicked, we populate the json according the original rows collection except for the section data
             *  (attribute model) where the save has been clicked (taken from the current rows collection)
             * - if a save all button has been clicked, we build the json entirely from the current rows collection
             *
             * @returns {string}
             * @private
             */
            _buildScraperConfigJson: function () {
                LEManager.logger.info("DataSourcesSdesController:_buildScraperConfigJson - started");

                var that = this, dataSourcesAttributeModel = null, lookup = null, propertyModel = null, result = [], id = -1, value = "", cleanup = "", nonEmptyPropertyFound = false, rowIdToDelete = [], originalAttributeModel={}, foundUnsave= false, currentPropModel = null;

                //source is the template of the scraper info taglet we will use to populate the data from the collection
                var source = _.clone(AllSdes, true);

                if (source.length > 0) {
                    //we parse all the rows from the source json. if properties are found in the rows collection we populate it
                    //if not we remove the corresponding property section in the source. if no properties populated in the source
                    //we remove the whole row from the source
                    _.each(source, function (row) {
                        //current attribute model
                        dataSourcesAttributeModel = that.dataSourcesRowsCollection.getAttributeById((window.parseInt(row.id)));

                        nonEmptyPropertyFound = false;
                        if (dataSourcesAttributeModel) {
                            for (var prop in row.value.lookup) {
                                if (!that.context.scraperSave.saveAll && that.context.scraperSave.model.id !== dataSourcesAttributeModel.id) {
                                    //if a single save event and the model to save is different from the current model,
                                    //we will use the property model from the original collection (we take original values, we ignore all the changes in
                                    // the current property model as they're not relevant for this specific section save)
                                    originalAttributeModel = that.originalRowsCollection.getAttributeById((window.parseInt(row.id)));
                                    propertyModel = originalAttributeModel.getPropertiesCollection().getById(window.parseInt(prop));
                                    currentPropModel = dataSourcesAttributeModel.getPropertiesCollection().getById(window.parseInt(prop));
                                }
                                else {
                                    //in case we have a save all event or if the model to save is the same than the current model we will take the
                                    //properties from the current model
                                    propertyModel = dataSourcesAttributeModel.getPropertiesCollection().getById(window.parseInt(prop));
                                }

                                if (propertyModel.isEditable()){
                                    id = propertyModel.getMapById();
                                    value = propertyModel.getMapByValue();
                                    cleanup = propertyModel.getCleanup();

                                    if (!propertyModel.hasMissingProperties()) {//if the user has inputted both map id and value
                                        nonEmptyPropertyFound = true;
                                        //we build the lookup json accordingly
                                        lookup = that._formatLookupItem(id, value, cleanup);
                                        row.value.lookup[prop] = lookup;
                                    }
                                    else { //no values inputted by the user
                                        //row is empty - remove the SDE corresponding empty row references
                                        delete row.value.lookup[prop];
                                        GeneralUtils.objectDeepDelete("value.sde." + propertyModel.getSDEPath(), row);
                                    }
                                }
                            }
                        }
                        if (!nonEmptyPropertyFound) //if all the properties for the corresponding row are empty then remove the whole block
                        {
                            rowIdToDelete.push(row.id);
                        }

                    });
                    source = _.reject(source, function (item) {
                        return _.indexOf(rowIdToDelete, item.id) > -1;
                    });


                    for (var i = 0; i < source.length; i++) {
                        source[i].value = JSON.stringify(source[i].value); //only the inner config json is escaped
                    }
                    result = source;
                    //result = JSON.stringify(jsonExternal);
                    //this.context.propertiesChanged = foundUnsave;
                    //result = JSON.stringify(json).replace(/"/g, '\\"');
                }
                return result;
            },

            /**
             *                                  ############# _formatLookupItem #############
             * format the lookup object in the scraper taglet input
             *
             *
             * @param mapById - the map by id value
             * @param value - the value
             * @param cleanup - the cleanup regex
             * @returns {{}}
             */
            _formatLookupItem: function(mapById, value, cleanup){
                LEManager.logger.info("DataSourcesSdesController:_formatLookupItem - started");

                if (_.isUndefined(mapById)){
                    mapById = -1;
                }
                var obj = {};
                var mapBy = ManagerConfig.dataSources.mainConfig.scraper.mapping.map_by[mapById.toString()];
                obj[mapBy] = value;
                if(cleanup){
                    obj[CONST.CLEANUP] = cleanup;
                }
                return obj;
            },

            /****************************************************************** PUBLIC **********************************************************
             *
             */


            /**
             *                                   ############# getMainView #############
             *
             * return the page view
             *
             * @returns {*}
             */
            getMainView: function() {
                this._initPageComponent();
                return this.pageView;
            },

            /**
             *                                   ############# showDataSourceConfiguration #############
             *
             * shows the data source page
             */
            showDataSourceConfiguration:function (options) {
                LEManager.logger.debug("DataSourcesSdesController:showDataSourceList - started");
                var rowId, attributeId, rowModel = null;

                this.pageView.showLoader();

                this.attributesConfigLayout = new AttributesConfigLayout();

                this._initDataSourcesRowsCollection();
                if (options.rowId && !isNaN(parseInt(options.rowId, 10))) {
                    rowId = parseInt(options.rowId, 10);
                    rowModel = this.dataSourcesRowsCollection.getById(rowId);
                    this.context.attributeModel = null;
                    this.context.rowModel = rowModel;
                }
                if (options.attributeId && !isNaN(parseInt(options.attributeId, 10))) {
                    attributeId = parseInt(options.attributeId, 10);
                    this.context.attributeModel = this.dataSourcesRowsCollection.getAttributeById(attributeId);
                    rowModel = this.dataSourcesRowsCollection.getById(this.context.attributeModel.getParentId());
                    this.context.rowModel = rowModel;
                    rowId = rowModel.getId();
                }
                if (rowId > -1){
                    if (!_.isUndefined(this.context.rowModel)){
                        this.pageView.setTitle(this.context.rowModel.getName());
                        this.pageView.setDescription(this.context.rowModel.getDescription());

                        var done = _.after(2, _.bind(this._renderAttributesConfigView, this));

                        //this.listenToOnce(this.attributesConfigLayout, "render", _.bind(function(){
                        this._getTagletData(done);
                        //},this));
                        this._getAgentOutcome(done);

                        this.pageView.setInsideView(this.attributesConfigLayout);
                    }
                    else {
                        LEManager.logger.error("DataSourcesSdesController:showDataSourceConfiguration - could not find the model by id: " + options.dataSourceId);
                        LEManager.logger.graph({name:"manager:DataSourceSdesController:showDataSourceConfiguration:modelNotFound"});
                    }
                }
                else {
                    LEManager.logger.error("DataSourcesSdesController:showDataSourceConfiguration - options.dataSourceId is undefined. options: " + options);
                    LEManager.logger.graph({name:"manager:DataSourceSdesController:showDataSourceConfiguration:dataSourceIdUndefined"});
                }
                this.pageView.closeLoader();
            }

        });

    });
    return DataSourcesSdesController;
});
